import { render, staticRenderFns } from "./NovoAtendimentoAvulso.vue?vue&type=template&id=064d8872&"
import script from "./NovoAtendimentoAvulso.vue?vue&type=script&lang=js&"
export * from "./NovoAtendimentoAvulso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports